<script setup lang="ts">
import StyledModal from "@/components/_elements/modals/StyledModal.vue";
import { XMarkIcon } from "@heroicons/vue/20/solid";

const props = withDefaults(
    defineProps<{
        title: string;
        dismissalKey: string;
        buttonLabel?: string;
    }>(),
    { buttonLabel: "Got it" }
);

const show = localStorage.getItem(props.dismissalKey) !== "true";

const onClose = () => {
    localStorage.setItem(props.dismissalKey, "true");
};
</script>

<template>
    <StyledModal :start-open="show" @on-close="onClose">
        <template v-slot:panel="slotProps">
            <!-- active:top-4 stops the global `button:active { top: 2px }` rule from moving this button. -->
            <button
                class="absolute top-4 right-4 active:top-4 text-gray-800 hover:text-black"
                @click="slotProps.events?.closeModal()"
            >
                <XMarkIcon class="w-6 h-6"></XMarkIcon>
                <span class="sr-only">Close</span>
            </button>

            <h2
                class="mt-2 mb-0 pr-8 text-2xl leading-8 font-bold text-gray-800"
            >
                {{ title }}
            </h2>

            <div class="mt-5 text-lg leading-7 text-gray-800 text-pretty">
                <slot />
            </div>

            <div class="flex mt-8 gap-2 items-center justify-center">
                <button
                    @click="slotProps.events?.closeModal()"
                    class="hover:cursor-pointer button no-underline bg-blue-700 text-white rounded-md border-none hover:bg-blue-800 hover:text-white"
                >
                    {{ buttonLabel }}
                </button>
            </div>
        </template>
    </StyledModal>
</template>
